<template>
  <div>
    <PageHeader :title="title" :items="itemsPageHeader" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-8"></div>
              <div class="col-sm-4">
                <div class="text-sm-right">
                  <!-- <button
                    @click="
                      $router.push({
                        name: 'team_detail',
                        params: { id: 'new' },
                      })
                    "
                    type="button"
                    class="btn btn-success waves-effect waves-light"
                  >
                    <i class="bx bx-plus font-size-16 align-middle mr-2"></i>
                    New Team
                  </button> -->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <div class="form-row form-group">
                  <label class="col-md-2 col-form-label">ค้นหา</label>
                  <div class="col-md-6">
                    <input
                      v-model="filter.keyword"
                      type="text"
                      placeholder="ชื่อทีม / รหัสพนักงาน"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <div class="form-row form-group">
                  <label class="col-md-2 col-form-label">JDA Category</label>
                  <div class="col-md-6">
                    <!-- <MappingJDACategorySelector
                      :level="5"
                      :displayKey="`view_name`"
                      :idKey="`view_id`"
                      :childrenItemsKey="`items`"
                      :defaultValue="filter.jda_category_id"
                      :items="jdaCategoryItems"
                      :reload="isClearCategorySelector"
                      @result="onJDACategorySelector"
                      style="margin-bottom: -1rem"
                    ></MappingJDACategorySelector> -->
                    <multiselect
                      v-model="jdaSelectDropdown"
                      :options="jdaCategoryOptions"
                      :show-labels="false"
                      placeholder="เลือกหมวดหมู่"
                      :custom-label="item => item.view_name"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <div class="form-row form-group">
                  <label class="col-md-2 col-form-label">สถานะ</label>
                  <div class="col-form-label row" style="margin-left: 0px">
                    <b-form-checkbox
                      @change="onSelectAll($event)"
                      class="custom-checkbox-info mb-3"
                      style="margin-right: 10px"
                      name="all"
                      id="all"
                      v-model="selectAll"
                      >เลือกทั้งหมด</b-form-checkbox
                    >
                    <div
                      v-for="(data_status, index) in selectAllStatus"
                      :key="index"
                    >
                      <b-form-checkbox
                        v-model="filter.status"
                        :value="data_status"
                        class="custom-checkbox-info mb-3"
                        style="margin-right: 10px"
                        :name="data_status.toLowerCase()"
                        :id="data_status.toLowerCase()"
                        >{{ data_status }}
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 text-sm-right">
                <div class="button-items">
                  <button
                    type="button"
                    class="btn btn-primary waves-effect"
                    @click="onFilter()"
                  >
                    <i class="bx bx-search font-size-16 align-middle mr-2"></i>
                    Search
                  </button>
                  <button
                    type="button"
                    class="btn btn-light waves-effect"
                    @click="onReset()"
                  >
                    <i class="bx bx-reset font-size-16 align-middle mr-2"></i>
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-if="showDataTable">
          <div class="card-body">
            <div class="row form-group">
              <div class="col-sm-12 col-md-9">
                <div id="tickets-table_length" class="dataTables_length">
                  <span>จำนวน</span>
                  <label class="d-inline-flex align-items-center">
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      @change="onFilter()"
                      class="ml-3"
                    ></b-form-select>
                  </label>
                  <span class="ml-2"
                    >จากทั้งหมด {{ totalRecords | number }} รายการ</span
                  >
                </div>
              </div>
              <div class="col-sm-12 col-md-3">
                <div class="input-group md-form form-sm text-md-right">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <span class="bx bx-search-alt"></span>
                    </span>
                  </div>
                  <input
                    v-model="search"
                    class="form-control my-0 py-1"
                    type="search"
                    placeholder="ค้นหา"
                    aria-label="Search"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <b-table
                    class="table table-centered table-nowrap"
                    ref="myTable"
                    :empty-text="'ไม่พบข้อมูล'"
                    :show-empty="items.length == 0"
                    :bordered="true"
                    :filter="search"
                    :items="items"
                    align="center"
                    v-bind:fields="fields"
                    @filtered="onFiltered"
                    :perPage="perPage"
                  >
                    <template v-slot:cell(index)="data">
                      <div class="text-right">
                        {{ (firstRowOnPage + data.index) | number }}
                      </div>
                    </template>
                    <template v-slot:cell(category_control)="data">
                      <div
                        class="text-left"
                        v-if="data.value && data.value.category_control_code"
                      >
                        <!-- {{data.value.category_control_id}} -->
                        <!-- {{jdaCategoryOptions}} -->
                        {{
                          jdaCategoryOptions.find(
                            f => f.view_id === data.value.category_control_id
                          ) === undefined
                            ? ''
                            : jdaCategoryOptions.find(
                                f =>
                                  f.view_id === data.value.category_control_id
                              ).view_name
                        }}
                      </div>
                    </template>
                    <template v-slot:cell(status)="data">
                      <span
                        class="label"
                        :class="'label-' + data.value.toLowerCase()"
                        v-html="data.value"
                        v-if="data.value !== ''"
                      ></span>
                    </template>
                    <template v-slot:cell(action)="data">
                      <div class="text-center">
                        <a
                          @click="
                            $router.push({
                              name: 'team_detail',
                              params: { id: data.item.id },
                            })
                          "
                          class="btn btn-ico text-info"
                          title="View"
                          ><i class="bx bx-show"></i
                        ></a>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
            <div class="row" v-if="items.length > 0">
              <div class="col-lg-4">
                <div style="position: relative; top: 7px">
                  รายการที่ {{ firstRowOnPage | number }} -
                  {{ lastRowOnPage | number }} จากทั้งหมด
                  {{ totalRecords | number }} รายการ
                </div>
              </div>
              <div class="col-lg-8">
                <b-pagination
                  :total-rows="totalRecords"
                  :per-page="perPage"
                  v-model="pageNo"
                  @change="onClickPagination($event)"
                  class="pagination pagination-rounded justify-content-end mb-2"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import { FormatQty } from '@/helpers/utils/format-qty.js'
import teamService from '@/helpers/service/team-service'
import jdaCategoryService from '@/helpers/service/jda-category-service'

import PageHeader from '@/components/page-header'
import { StatusEnum } from '@/enum/status.enum.js'
import appConfig from '@/app.config'
import { eventBus } from '@/main.js'
import { teamComputed, teamMethods } from '@/state/helpers'
// import MappingJDACategorySelector from '@/components/mappinghybridcategory/mapping-hybrid-category-selector'
import { OptionCheckboxStatus } from '@/helpers/utils/status.js'
import Multiselect from 'vue-multiselect'

export default {
  name: 'team',
  page: {
    title: 'Team',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { PageHeader, Multiselect },
  data() {
    return {
      search: null,
      title: 'Team',
      itemsPageHeader: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Team',
          active: true,
        },
      ],
      fields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'display_name',
          label: 'ชื่อ',
          sortable: true,
        },
        {
          key: 'category_control',
          label: 'หมวดหมู่สินค้า',
          tdClass: 'text-center',
          thStyle: 'width:120px',
          sortable: true,
        },
        {
          key: 'status',
          label: 'สถานะ',
          tdClass: 'text-center',
          thStyle: 'width:120px',
          sortable: true,
        },
        {
          key: 'action',
          label: 'Action',
          thStyle: 'width:80px',
        },
      ],
      listModel: {
        type: Object,
        default: () => {
          return {
            firstRowOnPage: 0,
            items: [],
            lastRowOnPage: 0,
            pageNo: 1,
            totalPages: 0,
            totalRecords: 0,
            pageSize: 10,
            prevPage: 0,
            nextPage: 0,
          }
        },
      },
      items: [],
      pageNo: 1,
      totalPages: 0,
      firstRowOnPage: 0,
      lastRowOnPage: 0,
      totalRecords: 0,
      perPage: 10,
      filter: {
        id: null,
        keyword: '',
        status: [],
        jda_category_id: '',
      },
      selectAll: false,
      selectAllStatus: [],
      pageOptions: [10, 25, 50, 100],
      showDataTable: false,
      jdaCategoryItems: [],
      isClearCategorySelector: false,
      jdaCategoryOptions: [],
      jdaSelectDropdown: '',
    }
  },
  computed: {
    ...teamComputed,
  },
  async mounted() {
    this.selectAllStatus = OptionCheckboxStatus
    await this.getJDACategory()
    this.filter = Object.assign({}, this.GET_FILTER_TEAM)
    if (this.filter.isFilter) {
      await this.onFilter()
    }
  },
  watch: {
    'filter.status': {
      handler() {
        this.selectAll =
          this.filter.status.length === this.selectAllStatus.length
            ? true
            : false
      },
      deep: true,
    },
    GET_FILTER_TEAM(val, oldVal) {
      this.filter = Object.assign({}, val)
    },
    listModel: function(value) {
      console.log('555')
      console.log(value)
      this.totalPages = value.totalPages
      this.firstRowOnPage = (value.pageNo - 1) * value.pageSize + 1
      this.lastRowOnPage =
        value.pageSize <= 0
          ? value.totalRecords
          : Math.min(value.pageNo * value.pageSize, value.totalRecords)
      this.totalRecords = value.totalRecords

      if (this.showDataTable) {
        this.$refs.myTable.localSortBy = ''
      }
      this.items = value.items.filter(s => s.display_name !== 'Vendor')
      this.perPage = value.pageSize
      this.pageNo = value.pageNo
    },

    jdaSelectDropdown(val) {
      if (val === '') this.filter.jda_category_id = ''
      else this.filter.jda_category_id = val.view_id
    },
  },
  methods: {
    ...teamMethods,
    async onFiltered(filteredItems) {
      this.totalPages = filteredItems.length
    },
    onSelectAll(event) {
      this.filter.status = event ? this.selectAllStatus : []
    },
    async onClickPagination(pageNo) {
      this.search = ''
      let params = new URLSearchParams()
      params.append('pageSize', this.perPage)
      params.append('pageNo', pageNo)
      params.append('keyword', this.filter.keyword.trim() || '')
      params.append(
        'category_control_id',
        this.filter.jda_category_id.trim() || ''
      )
      params.append('sort', 'create_info.timestamp')
      this.filter.status.forEach(element => {
        params.append('status', element)
      })
      let result = await teamService.getteamMasterListAsync(params)
      if (result.status === 200) {
        this.listModel = result.data
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        console.log('error', result.response.data.message)
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onFilter() {
      this.showDataTable = true
      let params = new URLSearchParams()
      params.append('pageSize', this.perPage)
      params.append('keyword', this.filter.keyword.trim() || '')
      params.append(
        'category_control_id',
        this.filter.jda_category_id.trim() || ''
      )
      params.append('sort', 'create_info.timestamp')
      this.filter.status.forEach(element => {
        params.append('status', element)
      })
      let result = await teamService.getteamMasterListAsync(params)
      if (result.status === 200) {
        console.log(result.data)
        this.listModel = result.data
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        console.log('error', result.response.data.message)
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
      this.ADD_FILTER_TEAM(this.filter)
    },
    onReset() {
      this.filter.id = null
      this.filter.keyword = ''
      this.filter.status = []
      this.filter.jda_category_id = ''
      this.isClearCategorySelector = !this.isClearCategorySelector
      this.jdaSelectDropdown = ''
    },
    async onConfirmDelete(id, name) {
      await this.$utils
        .confirmAlertDisplay(
          `คุณต้องการเปลี่ยนสถานะข้อมูล ${name} เป็น Delete ใช่หรือไม่`,
          ''
        )
        .then(result => {
          if (result) {
            this.onDelete(id)
          }
        })
    },
    async onDelete(id) {
      let result = await jdaCategoryService.deleteJDACategoryByIdAsync(id)
      if (result.status && result.status === 204) {
        this.$utils.notification(
          'success',
          'เปลี่ยนข้อมูลเป็นสถานะ Delete สำเร็จ',
          1500
        )
        this.onFilter()
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async getJDACategory() {
      let params = new URLSearchParams()
      params.append('is_free', true)
      params.append('is_free', false)
      params.append('status', StatusEnum.ACTIVE)
      let result = await jdaCategoryService.getMappingJDACategoryTreeNodeAsync(
        params
      )
      if (result.status === 200) {
        if (result.data.length) {
          this.jdaCategoryOptions = result.data
          this.jdaCategoryItems = result.data
        }
      }
    },
    onJDACategorySelector(obj) {
      this.filter.jda_category_id = obj.id
    },
  },
}
</script>
<style></style>
